import { matchPath, useLocation, useNavigate } from 'react-router-dom'

import tailwind from '_/tailwind.config'

import { AntTab, AntTabs } from 'common/components/AntTabs'
import {
  IQRANavUtilsConsumerComponentInitProps,
  QRAViewType
} from 'common/utils/navigation/qraNavUtils'

/**
 * Graph / Table tab navigation for QRA views
 * Tab navigation requires supporting routes to be defined in router
 * which is set up for QRA current state, saved state, compare states
 *
 * @param qraViewBasePath - URL path the tab selection generated url to be based on
 * @returns toggle component
 */
const GraphsAndTableTab = ({
  qraViewBasePath
}: IQRANavUtilsConsumerComponentInitProps) => {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()

  const pathMatch = matchPath(`${qraViewBasePath}/:tabView`, pathname)

  let selectedView = QRAViewType.Graph

  if (pathMatch != null && pathMatch.params.tabView === QRAViewType.Table) {
    selectedView = QRAViewType.Table
  }

  const handleTabSelect = (
    _event: React.ChangeEvent<object>,
    idx: number
  ): void => {
    const tabView = idx === 0 ? QRAViewType.Graph : QRAViewType.Table

    navigate(`${qraViewBasePath}/${tabView}${search}`)
  }

  return (
    <AntTabs
      value={selectedView === QRAViewType.Graph ? 0 : 1}
      onChange={handleTabSelect}
      style={{ minHeight: '40px', height: '40px' }}
    >
      <AntTab
        label='GRAPHS'
        sx={{
          fontWeight: 500,
          fontSize: 14,
          minHeight: '40px',
          minWidth: 0,
          height: '40px',
          lineHeight: 1,
          letterSpacing: '0.01em',
          px: '12px',
          color: tailwind.theme.colors.gray[500]
        }}
      />
      <AntTab
        label='DATA TABLE'
        sx={{
          fontWeight: 500,
          fontSize: 14,
          minHeight: '40px',
          minWidth: 0,
          height: '40px',
          lineHeight: 1,
          letterSpacing: '0.01em',
          px: '12px',
          color: tailwind.theme.colors.gray[500]
        }}
      />
    </AntTabs>
  )
}

export default GraphsAndTableTab
